import { CabinetReferenceConfigurationModel, CabinetReferenceType, InputType, ReferenceValidationType, SearchReferenceConfigurationModel, StoreReferenceConfigurationModel } from '@/types';

export const CabinetReferenceConfigurationModelDefaults: CabinetReferenceConfigurationModel = {
  id: null,
  key: '',
  documentTypeId: null,
  isDeleted: false,
  referenceType: CabinetReferenceType.Common,
  description: '',
  fieldNumber: null,
  referenceNumber: null,
  maximumLength: 255,
  displayOrder: null,
  isNew: false,
  canDelete: false,
  deletionDisabledReason: '',
  isMultiValue: false
};

export const CommonStoreReferenceConfigurationModelDefaults: StoreReferenceConfigurationModel = {
  referenceNumber: -1,
  useDefaults: true,
  lookup: false,
  required: true,
  mustExistInList: null,
  fixedLength: false,
  requiredLength: null,
  inputType: InputType.EnterOnly,
  upperCase: true,
  visible: true,
  validationType: ReferenceValidationType.AnyValue,
  listId: null
};

export const StoreReferenceConfigurationModelDefaults: StoreReferenceConfigurationModel = {
  referenceNumber: -1,
  useDefaults: false,
  lookup: false,
  required: true,
  mustExistInList: null,
  fixedLength: false,
  requiredLength: null,
  inputType: InputType.EnterOnly,
  upperCase: true,
  visible: true,
  validationType: ReferenceValidationType.AnyValue,
  listId: null
};

export const SearchReferenceConfigurationModelDefaults: SearchReferenceConfigurationModel = {
  referenceNumber: null,
  inputType: InputType.EnterOnly,
  upperCase: true,
  visible: true,
  validationType: ReferenceValidationType.AnyValue,
  listId: null
};
